export default {
  subtitle:
    "Analyse approfondie de la conformité carbone CBAM de l'UE pour aider les PME à comprendre rapidement les réglementations et les tendances du marché",
  feature1: "Introduction au CBAM",
  feature2: "Processus de conformité",
  feature3: "Tendances du marché",
  feature4: "Comment notre produit aide les entreprises",
  seo_title: "Guide de conformité carbone CBAM de l'UE",
  section1_title: "Introduction au CBAM",
  section1_content1:
    "Le Mécanisme d'Ajustement des Frontières Carbone (CBAM) de l'Union européenne est un outil politique important introduit par l'UE pour lutter contre le changement climatique.",
  section1_content2:
    "Ce mécanisme vise à prévenir la fuite de carbone et à garantir que les marchandises importées soient dans un environnement concurrentiel équitable avec les marchandises produites au sein de l'UE en termes de coûts d'émission de carbone.",
  section1_content3:
    "Le CBAM exige que les importateurs de biens à forte émission de carbone spécifiques dans l'UE achètent les quotas d'émission de carbone correspondants équivalents aux coûts de carbone supportés par les producteurs de l'UE.",
  section2_title: "Processus de conformité",
  section2_content: "Le processus de conformité CBAM comprend quatre étapes clés :",
  section2_step1:
    "Déclaration : Les importateurs doivent s'inscrire dans le système CBAM et déclarer régulièrement les émissions de carbone des marchandises importées",
  section2_step2:
    "Vérification : Les données d'émission de carbone déclarées doivent être vérifiées par une agence de vérification tierce",
  section2_step3:
    "Achat de quotas : Acheter les certificats CBAM correspondants en fonction des émissions de carbone vérifiées",
  section2_step4:
    "Douane : Les marchandises peuvent entrer sur le marché de l'UE après avoir achevé l'achat des certificats CBAM",
  section3_title: "Tendances du marché",
  section3_content:
    "Le CBAM évolue et se développe continuellement, avec les principales tendances suivantes :",
  section3_trend1:
    "Élargissement de la portée : Le CBAM s'étendra progressivement à davantage d'industries, y compris les produits chimiques organiques et les produits plastiques",
  section3_trend2:
    "Normes plus strictes : L'UE continuera d'améliorer les exigences de précision et de transparence pour le comptage des émissions de carbone",
  section3_trend3:
    "Impact mondial : Le CBAM pousse les partenaires commerciaux mondiaux à établir ou ajuster leurs propres mécanismes de fixation des prix du carbone",
  section3_trend4:
    "Développement technologique : Les outils numériques et les systèmes automatisés jouent un rôle de plus en plus important dans le comptage des émissions de carbone",
  section4_title: "Comment notre produit aide les entreprises",
  section4_content:
    "Notre produit peut aider les entreprises à répondre efficacement aux exigences de conformité CBAM :",
  section4_benefit1:
    "Calcul précis : Fournit des calculs précis des émissions de carbone basés sur les facteurs officiels de l'UE et les facteurs personnalisés",
  section4_benefit2:
    "Conformité efficace : Génère automatiquement des rapports conformes au CBAM, simplifiant le processus de déclaration",
  section4_benefit3:
    "Traitement par lots : Prend en charge le traitement de grandes quantités de données pour améliorer l'efficacité du travail",
  section4_benefit4:
    "Intégration API : S'intègre facilement aux systèmes ERP et e-commerce pour réaliser un reporting de conformité automatisé",
  download_title: "Télécharger le livre blanc maintenant",
  email_placeholder: "Veuillez saisir votre email",
  agreement_text:
    "J'accepte d'utiliser cet email pour recevoir le livre blanc et j'accepte que mes données personnelles soient traitées conformément aux exigences du RGPD.",
  privacy_policy: "Voir la politique de confidentialité",
  download_button: "Télécharger le livre blanc (PDF)",
  download_generating: "Génération en cours...",
  email_required: "Veuillez saisir votre email",
  agreement_required: "Veuillez accepter la politique de confidentialité",
  download_success: "Livre blanc téléchargé avec succès, merci d'utiliser notre service !",
  download_failed: "Échec du téléchargement, veuillez réessayer ultérieurement",
  submit_error: "Échec de la soumission, veuillez réessayer ultérieurement",
};
